export default __webpack_public_path__ + "static/media/graylog.563f4e39.svg";